import { Environment } from './app-settings'

const generateRepresentativePageUrl = (path: string | undefined): string => {
   if(path === undefined) {
      console.error("Nie udało się zbudować linku do strony wizytówki")
      return ''
   }
   const getLastSlashRegexp = /\/$/
   return `${Environment.representativePageUrl.replace(getLastSlashRegexp, '')}/${path.replace("/", "")}`
}


export const AppLinks = {
   default: '/',
   start: '/start',
   return: '/return',
   affiliate: process.env.NODE_ENV === 'development' ? '/affiliate' : process.env.REACT_APP_AFFILIATE_URL_PATH ?? '',
   error: '/cos-poszlo-nie-tak',
   fail: '/odmowa',
   offert: '/oferta',
   customOffer: '/wybierz-oferte',
   success: '/success',
   waiting: '/daj-nam-chwile',
   houston: '/brak-internetu',
   bmverify: '/wybierz-bank',
   kontomatikSignInRedirectionReturnError:'/wybierz-bank-blad',

   sessionEnd: '/sesja-wygasla',
   contractSigning: '/podpisz-umowe',
   manualVerification: '/porozmawiajmy',
   manualVerificationHubRedirection: '/porozmawiajmy-metoda-potwierdzona',
   manualVerificationFailPage: '/weryfikacja-danych-nieudana',
   clientPeselReservedPage: '/numer-pesel-zastrzezony',
   clientChoiceManualVerification: '/wybor-metody-weryfikacji',
   contractDone: '/umowa-uruchomiona',
   manualVerificationclientPeselReservedPage: '/weryfikacja-numer-pesel-zastrzezony',

   basicInfoForm: process.env.NODE_ENV === 'development' ? '/formularz/zloz-wniosek' : process.env.REACT_APP_FORM_STARTING_URL_PATH ?? '',
   extendedInfoForm: '/formularz/dane-osobowe',
   addressInfoForm: '/formularz/adresy',
   incomeInfoForm: '/formularz/dane-dochodowe',

   // WIDEO WERYFIKACJA
   videoVerificationStartManualVerificationPage: '/wideo-weryfikacja-potwierdz-dane',
   videoVerificationManualVerificationErrorPage: '/wideo-weryfikacja-blad-weryfikacji-danych',
   videoVerificationBackFromPartner: '/wideo-weryfikacja-powrot',

   // mObywatel
   manualVerificationMObywatelIdentityPage: '/weryfikacja-mobywatel',

   // Czekadełka
   bmWaiting: '/analizujemy-dane',
   offerWaiting: '/weryfikujemy-dane',

   howItWorks: generateRepresentativePageUrl(process.env.NODE_ENV === 'development' ? 'jak-to-dziala' : process.env.REACT_APP_REPRESENTATIVE_PAGE_HOW_IT_WORKS_URL_PATH),
   faq: generateRepresentativePageUrl(process.env.NODE_ENV === 'development' ? 'pytania-i-odpowiedzi' : process.env.REACT_APP_REPRESENTATIVE_PAGE_FAQ_URL_PATH),
   contact: generateRepresentativePageUrl(process.env.NODE_ENV === 'development' ? 'kontakt' : process.env.REACT_APP_REPRESENTATIVE_PAGE_CONTACT_URL_PATH),
   docsToDownload: generateRepresentativePageUrl(process.env.NODE_ENV === 'development' ? 'dokumenty' : process.env.REACT_APP_REPRESENTATIVE_PAGE_DOC_TO_DOWNLOAD_URL_PATH),
}